import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Box, Heading } from '@components/common';
import { MobileContainer } from '@containers/layout';
import SelectorButton from '@components/SelectorButton';
import DiscontinueActions, {
  DISCONTINUE_TYPE,
  DiscontinueSelectors
} from '@redux/DiscontinueRedux';

const ButtonWrapper = styled(SelectorButton)`
  width: 164px;
  height: 164px;
`;

function Frequency(props) {
  const { discontinueType, setDiscontinueType, onSubmit } = props;

  return (
    <MobileContainer>
      <Heading px={2} mb={4}>
        Would you prefer to pause services for now?
      </Heading>

      <Box px={2} display="flex" flexDirection="row">
        <ButtonWrapper
          selected={discontinueType === DISCONTINUE_TYPE.PAUSE}
          title="Pause for now"
          icon="single-occurence"
          iconColor="gold"
          onClick={() => {
            setDiscontinueType(DISCONTINUE_TYPE.PAUSE);
            onSubmit(true);
          }}
          mr={2}
        />
        <ButtonWrapper
          selected={discontinueType === DISCONTINUE_TYPE.DISCONTINUE}
          title="End completely"
          icon="recurring-occurence"
          iconColor="gold"
          onClick={() => {
            setDiscontinueType(DISCONTINUE_TYPE.DISCONTINUE);
            onSubmit();
          }}
        />
      </Box>
    </MobileContainer>
  );
}

Frequency.propTypes = {
  discontinueType: PropTypes.string,
  setDiscontinueType: PropTypes.func,
  onSubmit: PropTypes.func.isRequired
};

const mapStatesToProps = state => ({
  discontinueType: DiscontinueSelectors.selectType(state)
});

const mapDispatchToProps = dispatch => ({
  setDiscontinueType: frequency =>
    dispatch(DiscontinueActions.setDiscontinueType(frequency))
});

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(Frequency);
